import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { TreatmentsWidget } from './TreatmentsWidget'

class HoldstyringTreatmentsElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return TreatmentsWidget
  }

  // Supported HTML attributes:
  //   show-price="false"     — hide price line (default: visible)
  //   show-duration="false"  — hide duration (default: visible)
  //   show-benefits="false"  — hide benefits checklist (default: visible)
  //   title="Behandlinger"   — heading shown above the cards (default: none)
  protected getWidgetProps() {
    return {
      showPrice: this.getAttribute('show-price') !== 'false',
      showDuration: this.getAttribute('show-duration') !== 'false',
      showBenefits: this.getAttribute('show-benefits') !== 'false',
      title: this.getAttribute('title') || null,
    }
  }
}

if (!customElements.get('holdstyring-treatments')) {
  customElements.define('holdstyring-treatments', HoldstyringTreatmentsElement)
}

export { HoldstyringTreatmentsElement }
